module.exports = __webpack_public_path__ + "img/app.d4b652f4.svg";